import { IoWarning } from 'react-icons/io5';

type ReadOnlyProjectBannerProps = {
  onUpgradeClick?: () => void;
};

export const ReadOnlyProjectBanner = ({
  onUpgradeClick,
}: ReadOnlyProjectBannerProps) => {
  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-3">
      <div className="flex items-center justify-between max-w-screen-xl mx-auto">
        <div className="flex items-center gap-3">
          <IoWarning className="w-5 h-5 text-amber-600 flex-shrink-0" />
          <div>
            <p className="text-sm font-medium text-amber-800">
              This project is read-only
            </p>
            <p className="text-xs text-amber-700">
              Your organization has exceeded its project limit. You can view and
              export, but changes cannot be saved.
            </p>
          </div>
        </div>
        {onUpgradeClick && (
          <button
            onClick={onUpgradeClick}
            className="ml-4 px-4 py-1.5 bg-amber-600 text-white rounded-md hover:bg-amber-700 text-sm font-medium flex-shrink-0"
          >
            Upgrade Plan
          </button>
        )}
      </div>
    </div>
  );
};
